// extracted by mini-css-extract-plugin
export default {"header":"styles_header__g6yvu","title":"styles_title__EkMHV","item":"styles_item__g4CHC","imageWrapper":"styles_imageWrapper__V1SFb"};